<div class="flex flex-col" [ngClass]="{ 'mt-20px md:mt-30px': topMargin }">
    <span class="header-small">{{ title | translate }}</span>
    @if (items) {
        <div class="flex flex-col mt-10px">
            @for (item of items; track item) {
                <span class="flex flex-col body-copy" [innerHTML]="item | translate"> </span>
            }
        </div>
    }
</div>
